import classNames from 'classnames'
import { useCallback } from 'react'

import { BackButton, MainButton } from '@ds'
import { SecretInputs } from '@shared'

import styles from './QuestInputsLayout.module.scss'

interface TextMessage {
  message: string
  author?: string
}

interface QuestInputsLayoutProps {
  state: boolean
  mask?: number[]
  value: string
  focus?: boolean
  text?: TextMessage
  setValue: (value: string | ((prev: string) => string)) => void
  handleComplete: (value: string) => void
  onCloseTrigger: () => void
  keyBoardType?: 'text' | 'numeric'
  className?: string
}

export const QuestInputsLayout = ({
  state,
  mask,
  value,
  focus = true,
  text,
  setValue,
  handleComplete,
  onCloseTrigger,
  keyBoardType,
  className,
}: QuestInputsLayoutProps) => {
  if (!state) {
    return null
  }

  const handleBackdropInteraction = useCallback(
    (
      e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
    ) => {
      if (e.target === e.currentTarget) {
        e.preventDefault();
        e.stopPropagation();
        onCloseTrigger();
      }
    },
    [onCloseTrigger]
  )

  return (
    <>
      <BackButton onClick={onCloseTrigger} />
      <MainButton hidden />
      <div
        className={classNames(styles.questInputsLayout, className)}
        onClick={handleBackdropInteraction}
        onTouchEnd={handleBackdropInteraction}
      >
        <div className={styles.contentContainer}>
          <div className={styles.content}>
            <SecretInputs
              value={value}
              setValue={(newValue) => setValue(newValue)}
              mask={mask || []}
              onComplete={handleComplete}
              focus={focus}
              keyBoardType={keyBoardType}
            />
          </div>
          {text &&  (
            <div className={styles.textContentContainer}>
              <span className={classNames({ [styles.message]: text?.author })}>
                {text?.message}
              </span>
              {text?.message && text?.author && (
                <div className={styles.authorContainer}>
                  <img src="/assets/dialog/indicator.svg" />
                  <span>{text.author}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}